export function canvas(state = {}, action) {
  if (action.type === 'UPLOAD_FILES') {
    return action.files;
  }
  return state;
}
